import { render, staticRenderFns } from "./Detalhe.html?vue&type=template&id=0827dbc6&scoped=true&"
import script from "./Detalhe.vue?vue&type=script&lang=js&"
export * from "./Detalhe.vue?vue&type=script&lang=js&"
import style0 from "./Detalhe.scss?vue&type=style&index=0&id=0827dbc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0827dbc6",
  null
  
)

export default component.exports